import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EmissionsGridComponent } from './components/emissions-grid/emissions-grid.component';

@Component({
  imports: [EmissionsGridComponent],
  selector: 'app-emissions-page-page',
  templateUrl: './emissions-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../styles/page.scss'],
})
export class EmissionsPageComponent {}
